// Remembers where a logged-out user was trying to go (e.g. an approval link from
// an email) so login can send them there instead of the dashboard.
const KEY = 'postLoginRedirect';

const isSafePath = (p) => typeof p === 'string' && p.startsWith('/') && !p.startsWith('//') && !p.startsWith('/login') && !p.startsWith('/auth-callback');

export const rememberRedirect = (path) => {
  try { if (isSafePath(path) && path !== '/' ) sessionStorage.setItem(KEY, path); } catch { /* storage blocked */ }
};

// Returns the remembered path (and forgets it), or null.
export const consumeRedirect = () => {
  try {
    const p = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return isSafePath(p) ? p : null;
  } catch { return null; }
};
